import { render, staticRenderFns } from "./MaterialReplacement.vue?vue&type=template&id=24be430c&scoped=true&"
import script from "./MaterialReplacement.vue?vue&type=script&lang=js&"
export * from "./MaterialReplacement.vue?vue&type=script&lang=js&"
import style0 from "./MaterialReplacement.vue?vue&type=style&index=0&id=24be430c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24be430c",
  null
  
)

export default component.exports